import Vue from 'vue';
import { capitalize } from 'lodash';


Vue.filter('capitalize', _value => capitalize(_value));
